import { render, staticRenderFns } from "./EditGroupCourse.vue?vue&type=template&id=45b86889&scoped=true&"
import script from "./EditGroupCourse.vue?vue&type=script&lang=js&"
export * from "./EditGroupCourse.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupCourse.vue?vue&type=style&index=0&id=45b86889&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b86889",
  null
  
)

export default component.exports